'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PopupPanel = require('../../../../components/popupPanel/PopupPanel');

var _PopupPanel2 = _interopRequireDefault(_PopupPanel);

require('./RootBoardSharingPopup.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RootBoardSharingPopup = function RootBoardSharingPopup(props) {
    return _react2.default.createElement(
        _PopupPanel2.default,
        { className: 'RootBoardSharingPopup tooltip',
            popupId: 'sharing-tooltip',
            arrowDir: 'top',
            duration: 6000,
            fadeIn: true },
        _react2.default.createElement(
            'span',
            null,
            'Your main board is always private, ',
            _react2.default.createElement('br', null),
            'but any other board you create can be shared'
        )
    );
};

exports.default = RootBoardSharingPopup;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/sharing/RootBoardSharingPopup.js
// module id = 2191
// module chunks = 0